// Override Shopify.formatMoney to always cut off decimals (no rounding)
(function() {
  var defaultFormat = "{{amount}}";

  function formatWhole(number, format) {
    var f = (format || Shopify.money_format || defaultFormat);

    var useDotThousands =
      f.indexOf("amount_with_comma_separator") !== -1 ||
      f.indexOf("amount_no_decimals_with_comma_separator") !== -1;

    var thousands = useDotThousands ? "." : ",";
    var parts = number.toString().split("");
    var out = [];
    var count = 0;

    for (var i = parts.length - 1; i >= 0; i--) {
      out.unshift(parts[i]);
      count++;
      if (count % 3 === 0 && i !== 0) out.unshift(thousands);
    }

    return f
      .replace("{{amount_with_comma_separator}}", out.join(""))
      .replace("{{amount_no_decimals_with_comma_separator}}", out.join(""))
      .replace("{{amount_no_decimals}}", out.join(""))
      .replace("{{amount}}", out.join(""));
  }

  var _originalFormatMoney = Shopify.formatMoney;

  Shopify.formatMoney = function(cents, format) {
    if (typeof cents === "string") cents = cents.replace(".", "");
    var value = parseInt(cents, 10);
    if (isNaN(value)) value = 0;

    // Convert to base unit, then cut off (floor)
    var floored = Math.floor(value / 100);

    return formatWhole(floored, format);
  };

  // Optional helpers
  window.ShopNoDecimals = {
    floor: Shopify.formatMoney,
    original: _originalFormatMoney
  };
})();

